module.exports = __webpack_public_path__ + "img/share_invite.bc0de543.png";